export const SET_SETTING = 'SETTING/SET_SETTING'
export const SET_STATUSLIST = 'SETTING/SET_STATUSLIST'
